import { type FlagsManager } from '@databases/flags-types';
// FIXME circular dependency between service-container and flags
// eslint-disable-next-line workspaces/require-dependency
import { container } from '@databases/service-container';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { DefaultFlagGroup } from './DefaultFlagGroup';

export function mountDefaultFlagGroup(
  mount?: (el: HTMLElement, flagsManager: FlagsManager) => void
): void {
  const fragment = document.createDocumentFragment();
  const el = document.createElement('div');

  fragment.appendChild(el);

  const flagsManager = container.resolve('FlagsManager');

  if (mount) {
    mount(el, flagsManager);
  } else {
    createRoot(el).render(
      <DefaultFlagGroup
        flags={flagsManager.flags}
        handleFlagDismiss={(flagId: number | string) =>
          flagsManager.handleFlagDismiss(flagId)
        }
      />
    );
  }

  document.body.append(fragment);
}
